// Import React and Hooks
import React, { useEffect } from 'react'
// Import Redux and Hooks
import { useAppSelector } from './../../hooks/useRedux'
// Import Components
import FloatImg from './FloatImg'



const OfferingImage = () => {



  // Use Selector
  const currentOffering = useAppSelector( state => state.general.currentOffering )



  return (
    <section className="offeringImage ">
      <FloatImg
          additionalClass="offeringImageDownload1"
          alt="Flores y pajaro"
          speed={ 0.021 }
          revert={ true }
          src={`${window.assetsURl}/imgs/shapes/florecillas2.png`} />
      <FloatImg
          additionalClass="offeringImageDownload2"
          alt="Flores y pajaro"
          speed={ 0.021 }
          revert={ true }
          src={`${window.assetsURl}/imgs/shapes/florecillas.png`} />
      <FloatImg
          additionalClass="offeringImageDownload3"
          alt="Flores y pajaro"
          speed={ 0.021 }
          revert={ true }
          src={`${window.assetsURl}/imgs/shapes/download3.png`} />
      <div className="offeringImage__beer">
        <img
          src={`${window.assetsURl}/imgs/product/beer-front-new.png`}
          alt="Vista frontal de la cerveza Victoria en lata"
          title="Vista frontal de la cerveza Victoria en lata"
          className="offeringImage__beer__front" />
        <img
          src={ currentOffering.photo }
          alt="Foto de persona"
          title="Foto de persona"
          className="offeringImage__beer__photo" />
          <p className="beerMask__front__name">
           { currentOffering.name }
          </p>
      </div>
      <div className="offeringImage__content">
        <p className="offeringImage__name">
         { currentOffering.name }
        </p>
        <p className="offeringImage__age">
          <img
            src={`${window.assetsURl}/imgs/petals/petal-5.svg`}
            alt="Pétalo de flor"
            title="Pétalo de flor"
            className="offeringImage__age__flower" />
          { currentOffering.age }
          <img
            src={`${window.assetsURl}/imgs/petals/petal-5.svg`}
            alt="Pétalo de flor"
            title="Pétalo de flor"
            className="offeringImage__age__flower" />
        </p>
        <p className="offeringImage__text">
         { currentOffering.dedicatedText }
        </p>
        <div className="offeringImage__dedicatedBy">
          Dedicada por: <br />{ currentOffering.dedicatedBy }
        </div>
      </div>
    </section>
  )
}



export default OfferingImage
